'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CloseModalPopover = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(CloseModalPopover, _Component);

  function CloseModalPopover() {
    (0, _classCallCheck3.default)(this, CloseModalPopover);
    return (0, _possibleConstructorReturn3.default)(this, (CloseModalPopover.__proto__ || (0, _getPrototypeOf2.default)(CloseModalPopover)).apply(this, arguments));
  }

  (0, _createClass3.default)(CloseModalPopover, [{
    key: 'handleSave',
    value: function handleSave() {
      this.props.save();
    }
  }, {
    key: 'handleCloseModal',
    value: function handleCloseModal() {
      this.props.close();
    }
  }, {
    key: 'render',
    value: function render() {
      var polyglot = this.props.polyglot;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'simple-content' },
          _react2.default.createElement(
            'p',
            null,
            polyglot.t(this.props.scope + '.form.confirmSave')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'popover-actions' },
          _react2.default.createElement(
            'div',
            { className: 'buttons' },
            _react2.default.createElement(
              'button',
              {
                type: 'button',
                className: 'btn btn-default btn-cancel',
                onClick: this.handleCloseModal.bind(this)
              },
              polyglot.t('form.dontSave')
            ),
            '\xA0',
            _react2.default.createElement(
              'button',
              {
                type: 'button',
                className: 'btn btn-primary',
                onClick: !this.props.saving ? this.handleSave.bind(this) : null,
                disabled: this.props.saving
              },
              polyglot.t('form.save')
            )
          )
        )
      );
    }
  }]);
  return CloseModalPopover;
}(_react.Component), _class.propTypes = {
  close: _propTypes2.default.func.isRequired,
  polyglot: _propTypes2.default.object.isRequired,
  save: _propTypes2.default.func.isRequired,
  saving: _propTypes2.default.bool.isRequired,
  scope: _propTypes2.default.string.isRequired
}, _temp);
exports.default = CloseModalPopover;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/CloseModalPopover.js
// module id = 2202
// module chunks = 0